/**
 * To safely access window instance in SSR.
 */ export const getWindow = ()=>typeof window !== 'undefined' ? window : {
        ...globalThis,
        innerWidth: 0,
        innerHeight: 0,
        matchMedia: ()=>({
                matches: false
            })
    };

//# sourceMappingURL=getWindow.js.map